import { useIsLoggedInFromAuthStore } from "features/auth/hooks/useAuthStore";

/** Lectura de sesión vía authStore (sincronizado en authSessionService). */
export default function useIsLoggedIn(): boolean {
    return useIsLoggedInFromAuthStore();
}
